import React, { Component, PureComponent } from 'react'
import { connect } from 'react-redux'
import { VideoPlayer } from '../../legacy'
import { AUDIO_PLAY, AUDIO_STOP, AUDIO_SUPP, stopAudio, playAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { setPanoStartLatLon } from 'aria-viewer/players/panoplayer/actions/panoramaActions'
import { VideoPlayerUI } from 'aria-viewer/players/videoplayer'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'
import { hideContextMenu } from 'aria-viewer/contextmenu/contextMenuActions'
import { setDragHintDetails } from 'aria-viewer/interactive-element/actions/common'
import compose from 'recompose/compose'
import isEqual from 'lodash-es/isEqual'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import StopCardStates from 'aria-viewer/stopselector/constants/StopCardStates'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import waitForAction from 'aria-viewer/utils/waitForAction'
import 'public/assets/css/tour/videoui.scss'
import SkipButton from 'aria-viewer/tour/components/buttons/skipButton'
import { hideCustomMedia, showUIButton, isAutoPlayBlocked } from 'aria-viewer/tour/tourActions'
import { hideDescription } from 'aria-viewer/tour/components/buttons/desktopAudioButton'
import mobileDetect from 'aria-viewer/utils/mobileDetect'
import { PLATFORM } from 'aria-viewer/tour/constants/'
import Style from 'style-it'
import DraggingHint from './containers/DraggingHint'
import grabCursor from 'public/assets/cursors/grab.cur'
import grabbingCursor from 'public/assets/cursors/grabbing.cur'
import { VIDEO_SKIP_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import YouTubeIframe from 'aria-viewer/interactive-element/components/2d/player/YouTubeIframe'

/*=============================================
 =            	Environment                   =
 =============================================*/

// TODO : put an environment slice into redux
// TODO : and do not calculate these repeatedly
// TODO : in entire app

const isPhone = mobileDetect.phone()
const isMobile = mobileDetect.mobile()

/*=============================================
 =             		Constants                 =
 =============================================*/

const UIHideTiming = {
    IMMEDIATE: 0,
    FASTER: 250,
    FAST: 500,
    SLOW: 3000,
}

// FOR WINDOW TRACKINg //
const VIDEO_PLAYER = 'VIDEO_PLAYER'

// for measuring/triggering mouse clicks
const MOUSE_CLICK_THRESHHOLD_MS = 320,
    MOUSE_DISTANCE_THRESHHOLD_PX = 50

/*=============================================
 =             Component Styling              =
 =============================================*/

const S = {
    videoUIContainer: {
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2001,
    },
    videoWithoutPointerEvents: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
    },
    videoWithPointerEvents: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'all',
    },
    caretButton: {
        position: 'absolute',
        top: '1.55em',
        left: '1.05em',
        zIndex: 100,
        transform: 'rotate(90deg)',
    },
}

const StyleHelpers = {
    videoPlayerWrapper: ({ cursorClassName, originalStyle }) => ({
        originalStyle,
        cursorClassName,
        style: {
            position: 'relative',
            overflow: 'hidden',
            display: 'inline-block',
            pointerEvents: 'all',
            zIndex: 0,
            ...originalStyle,
        },
    }),
}

/*=============================================
 =         Supplementary Functions            =
 =============================================*/

function getMouseCoordinates(e) {
    if (e.changedTouches && e.changedTouches[0]) {
        return {
            x: e.changedTouches[0].clientX,
            y: e.changedTouches[0].clientY,
        }
    } else if (e.clientX && e.clientY) {
        return { x: e.clientX, y: e.clientY }
    } else return null
}

/*=============================================
 =              React Component               =
 =============================================*/

// NOTE : should this be PureComponent? [needs to be tested]

// TODO : when videoPlayer is put into state,
// TODO   we can directly modify player volume
// TODO   in the reducer instead of in a component

class VideoPlayerWrapper extends Component {
    constructor(props) {
        super(props)

        // TODO: this should definitely not be necessity
        // TODO: when we get to redux refactors

        // NOTE: these variables are bad practice
        //		 because they aren't redux props,
        //		 but in the case of mouse events,
        //		 we do not want to trigger thrash of
        // 		 re-render while pointing/dragging
        this.isMouseOnVideo = true
        this.mouseClickStartedAt = undefined
        this.mouseMoveStartPos = undefined
        this.lastMouseMoveTime = undefined

        // necessary evil for now
        this.lastPlayPauseProps = {
            audioManager: props.audioManager,
            audioType: props.audioType,
            allowedAudio: props.allowedAudio,
            canPlayMedia: props.canPlayMedia,
            wasPlaying: props.wasPlaying,
        }

        // for checking if a player was destroyed;
        // not necessary once redux is fixed
        this.playerWasDestroyed = false

        this.state = {
            player: null,
            isMouseDown: false,
            isVideoPlaying: false,
            shouldShowDragHint: false,
            hasShownDrag: false,
        }

        //cached styles
        this.CS = { videoPlayerWrapper: {} }

        // our references to React DOM elements
        this.R = {
            videoPlayerWrapper: undefined,
            videoPlayer: undefined,
        }
    }

    getContainerParentStyle = ({ cursorClassName, originalStyle }) => {
        if (
            this.CS.videoPlayerWrapper.cursorClassName != cursorClassName ||
            this.CS.videoPlayerWrapper.originalStyle != originalStyle
        ) {
            this.CS.videoPlayerWrapper = StyleHelpers.videoPlayerWrapper({ cursorClassName, originalStyle })
        }

        return this.CS.videoPlayerWrapper.style
    }

    /**
     * @param props
     * @param props.options VideoPlayer options
     */
    /**
     * @param props
     * @param props.options VideoPlayer options
     */
    delayedVideoPlayerInit = ({ options }) => {
        this.destroy()

        const player = VideoPlayer.createPlayer({
            ...options,
            disableShowDragHintOnLoad: true,
        })

        if (player) {
            player.embedPlayer(this.R.videoPlayer, '100%', '100%')

            // Hide UI after 3 seconds
            player.onPlay(this.handlePlay)

            // Have UI present on pause
            player.onPause(this.handlePause)
            player.onFinish(this.handleFinish)

            // Handle retrieving video quality list
            player.onReady(this.handleReady)

            player.on('dragstart', this.handleDragStart)
            player.on('dragend', this.props.dragVideoEnd)

            this.playerWasDestroyed = false
            this.setState({ player })
        }
    }

    handleDragStart = () => {
        if (this.props.isDraggingHintVisible) this.props.setDragHintDetails({ isVisible: false })
    }

    /**
     *  Behavior on Desktop to trigger toggle between
     *  playing and pausing after 1 second
     *
     *  NOTE: This is a really really bad paradigm.
     *        App state should not asynchronously battle
     *        with app state. Causes unnecessary delays,
     *        hard to follow logic, etc. Should be changed
     *        when React/Redux stuff is detangled.
     *
     * @param param {object}
     * @param param.audioManager
     * @param param.audioType
     * @param param.allowedAudio
     * @param param.explicitlyPlayOrPause 'play' || 'pause' a bit hacky --
     *                  explicitly set to play or pause (but hackyness comes with
     *                  turf in this React component)
     */
    togglePlayingAndPausing = ({ audioManager, audioType, allowedAudio, explicitlyPlayOrPause }) => {
        if (this.state.player && !isPhone) {
            //only apply behavior to desktop when player is there
            const wasPlaying = audioManager.getIn(['state', audioType]) == AUDIO_PLAY
            const canPlayMedia = allowedAudio == audioType

            let shouldTriggerPlayPause =
                typeof this.lastPlayPauseProps === 'undefined' ||
                audioManager != this.lastPlayPauseProps.audioManager ||
                audioType != this.lastPlayPauseProps.audioType ||
                allowedAudio != this.lastPlayPauseProps.allowedAudio ||
                canPlayMedia != this.lastPlayPauseProps.canPlayMedia ||
                wasPlaying != this.lastPlayPauseProps.wasPlaying

            if (shouldTriggerPlayPause) {
                // update our cache of relevant values to diff
                this.lastPlayPauseProps = {
                    audioManager,
                    audioType,
                    allowedAudio,
                    canPlayMedia,
                    wasPlaying,
                }

                clearTimeout(this.playPauseTimeout)
                this.playPauseTimeout = setTimeout(() => {
                    const wasPlaying = audioManager.getIn(['state', audioType]) == AUDIO_PLAY
                    const canPlayMedia = allowedAudio == audioType

                    if (
                        canPlayMedia &&
                        wasPlaying &&
                        ((explicitlyPlayOrPause && explicitlyPlayOrPause == 'play') || !explicitlyPlayOrPause)
                    ) {
                        this.state.player.play()
                        window[VIDEO_PLAYER] = AUDIO_PLAY
                    } else if (
                        !canPlayMedia &&
                        this.state.player.isPlaying() &&
                        ((explicitlyPlayOrPause && explicitlyPlayOrPause == 'pause') || !explicitlyPlayOrPause)
                    ) {
                        this.state.player.pause()
                        window[VIDEO_PLAYER] = AUDIO_STOP
                    } else if (!canPlayMedia && allowedAudio == AUDIO_SUPP) {
                        this.state.player.pause()
                        window[VIDEO_PLAYER] = AUDIO_STOP
                    }
                }, 10)
            }
        }
    }

    registerNewProps = props => {
        const {
            options,
            stopCardsState: nextStopCardState,
            allowedAudio,
            drawer,
            videoQuality,
            setStartTime,
            isRegistrationOpen,
        } = props

        const { stopCardsState, audioManager, audioType, videoStartTime } = this.props
        const { player } = this.state

        //pass in the newest audiomanager and audiotype unless its on first load
        let currentAudioManager = props.audioManager || audioManager
        let currentAudioType = props.audioType || audioType

        this.togglePlayingAndPausing({
            audioManager: currentAudioManager,
            audioType: currentAudioType,
            allowedAudio,
            explicitlyPlayOrPause: isRegistrationOpen ? 'pause' : `play`,
        })

        if (!isEqual(options, this.lastOptions)) {
            this.lastOptions = options

            clearTimeout(this.delayedRenderTimeout)

            this.delayedRenderTimeout = setTimeout(() => {
                this.delayedVideoPlayerInit(props)
            }, Number.parseInt(styleguide.delay.normal))
        }

        // Handle setting video players quality
        if (videoQuality && !isEqual(videoQuality, this.lastVideoQuality)) {
            this.lastVideoQuality = videoQuality

            player && player.setQuality(videoQuality)
        }

        // Handle the start duration of the video
        if (player && videoStartTime && videoQuality) {
            if (videoStartTime != -1) {
                player.seek(videoStartTime)
            } else {
                this.props.hideCustomMedia()
            }

            //set start time to null if it was already seeked
            setStartTime(null)
        }

        if (
            player &&
            player.isPlaying() &&
            allowedAudio != props.audioType &&
            ((stopCardsState == StopCardStates.SHOW) != (nextStopCardState == StopCardStates.SHOW) ||
                nextStopCardState != stopCardsState)
        ) {
            player.pause()
        }
    }

    componentWillMount() {
        // make sure the video UI is always showing
        // when first loading the videoPlayerWrapper
        this.props.showVideoUI()
    }

    componentDidMount() {
        this.registerNewProps(this.props)
        if (this.R.videoPlayer) {
            if (!this.is360()) {
                this.R.videoPlayer.addEventListener('mousemove', this.handleMouseOver)

                // only hide the UI when the mouse leaves on modals
                if (this.props.isFromModal) {
                    this.R.videoPlayer.addEventListener('mouseleave', this.hideUI)
                }
            } else {
                this.R.videoPlayer.addEventListener('mouseleave', this.props.cancelHideVideoUITimer)
            }
            this.props.hideDescription()
        }

        // NOTE: we should not put in arbitrary timers.
        // 		Most were taken out and this should also be taken out
        //		once we can delegate it to the action launchers themselves
        //	    (e.g. when Video/Audio players and logic
        //		have their own redux state slice and are controlled
        //		together and logically via actions)

        waitForAction({ time: 500 }).then(() => {
            this.hasComponentJustMounted = false
        })
    }

    componentWillUnmount() {
        this.destroy()
        this.props.stopAudio(this.props.audioType)
        window[VIDEO_PLAYER] = AUDIO_STOP

        clearTimeout(this.delayedRenderTimeout)

        if (this.R.videoPlayer) {
            if (!this.is360()) {
                this.R.videoPlayer.removeEventListener('mousemove', this.handleMouseOver)
                if (this.props.isFromModal) {
                    this.R.videoPlayer.removeEventListener('mouseleave', this.hideUI)
                }
            } else {
                this.R.videoPlayer.removeEventListener('mouseleave', this.props.cancelHideVideoUITimer)
            }

            if (this.is360() && (!this.props.panoStartLatLon || !this.props.panoStartLatLon.isSetByTrigger)) {
                this.props.setPanoStartLatLon({
                    lat: 0,
                    lon: 180,
                    isSetByTrigger: false,
                })
            }

            if (!this.props.isMediatour) this.props.showUIButton(true)
        }
    }

    destroy = () => {
        this.playerWasDestroyed = true
        clearTimeout(this.playPauseTimeout)
        if (this.state.player) {
            this.state.player.pause()
            this.state.player.destroy()
            this.setState({ player: null })
        }
    }

    componentWillReceiveProps(newProps) {
        this.registerNewProps(newProps)
    }

    handleVideoAreaClick = e => {
        this.mouseMoveStartPos = getMouseCoordinates(e)
        this.mouseClickStartedAt = new Date()

        this.setState({ isMouseDown: true })
    }

    handlePlay = e => {
        window[VIDEO_PLAYER] = AUDIO_PLAY
        this.props.onPlay && this.props.onPlay(this.state.player)

        this.playerWasDestroyed = false
        this.props.playVideo()
        this.setState({ isVideoPlaying: true, shouldShowDragHint: !this.state.hasShownDrag, hasShownDrag: true })

        const { player } = this.state

        this.hideUI(isPhone ? UIHideTiming.FAST : UIHideTiming.SLOW)

        if (player && !player.isPlaying()) {
            this.togglePlayingAndPausing({
                audioManager: this.props.audioManager,
                audioType: this.props.audioType,
                allowedAudio: this.props.allowedAudio,
            })

            this.initializeAudio()
            this.props.isAutoPlayBlocked(true)
        }
    }

    handlePause = e => {
        window[VIDEO_PLAYER] = AUDIO_STOP
        if (!this.playerWasDestroyed) {
            this.props.showVideoUI()
            this.setState({ isVideoPlaying: false })
        }
    }

    handleFinish = e => {
        window[VIDEO_PLAYER] = AUDIO_STOP
        this.playerWasDestroyed = true

        this.setState({ isVideoPlaying: false })

        if (this.props.altMainMedia) {
            // if it's an intro video
            // take the coordiantes on where the user is looking on the video
            // and set it as pano's starting coord
            if (this.is360() && (!this.props.panoStartLatLon || !this.props.panoStartLatLon.isSetByTrigger)) {
                //the panoplayer object that is on top of the videoplayer
                const panoPlayer = this.state.player._globalPlayer._panoPlayer
                if (panoPlayer) {
                    this.props.setPanoStartLatLon({
                        lat: panoPlayer.getLat(),
                        lon: panoPlayer.getLon(),
                        isSetByTrigger: false,
                    })
                }
            }
            this.props.hideCustomMedia()
        }

        this.props.isAutoPlayBlocked(false) //TODO: rename this :( ?
        this.props.stopAudio(this.props.audioType)
    }

    /**
     * called when mouse click detected
     */
    toggleUIVisibility = () => {
        if (!this.hasComponentJustMounted) {
            if (this.is360()) {
                if (!isPhone) {
                    if (this.props.isVideoUIVisible && this.isMouseOnVideo) {
                        this.hideUI()
                    } else {
                        this.props.showVideoUI(UIHideTiming.SLOW)
                    }
                } else if (isPhone) {
                    if (!this.props.isVideoUIVisible) {
                        this.props.showVideoUI(UIHideTiming.SLOW)
                    } else {
                        this.hideUI()
                    }
                }
            } else {
                // if this is a flat video and we're on mobile, we
                // don't care for the "isMouseOnVideo" value,
                // so on mobile, the logic is always just whether video UI
                // is visible, but Desktop also requires to check
                // the mouse interactioon
                if (this.props.isVideoUIVisible && (isPhone || this.isMouseOnVideo)) {
                    this.hideUI()
                } else if (isPhone || this.isMouseOnVideo) {
                    this.props.showVideoUI(UIHideTiming.SLOW)
                }
            }
        }
    }

    handleReady = e => {
        this.props.registerVideoPlayer(this.state.player)

        this.props.onLoad && this.props.onLoad(this.state.player)
        this.initializeAudio()

        if (this.isAWS() && !this.lastVideoQuality) {
            this.setVideoQuality()
        }
    }

    handleMouseOver = e => {}

    handleMouseMove = e => {
        // MouseMoveEnd event doesn't exist to put a listener on,
        // so we must track when mouse move was started to diff that amount

        this.lastMouseMoveTime = this.lastMouseMoveTime || new Date()
        let mouseMoveTimer = new Date().getTime() - this.lastMouseMoveTime.getTime()
        let lastMouseMoveTimeInScope = new Date(this.lastMouseMoveTime)

        // make sure we are not "clicking" since those events also fire with mouseMove
        if (mouseMoveTimer > MOUSE_CLICK_THRESHHOLD_MS) {
            if (this.state.isMouseDown) {
                this.isVideoBeingMoved = true
            }

            if (!this.is360()) {
                this.props.showVideoUI({ delay: 25, timeShown: 3000 })
            }
        }

        // The following timeout will simply reset the UI where appropriate
        setTimeout(() => {
            if (
                this.lastMouseMoveTime &&
                this.lastMouseMoveTime.getTime() >= lastMouseMoveTimeInScope.getTime() + 300
            ) {
                this.lastMouseMoveTime = undefined
            }
        }, 25)
    }

    handleMouseUp = e => {
        this.setState({ isMouseDown: false })

        if (this.mouseMoveStartPos) {
            // sanity check: in case we're in an environment
            // that didn't support our mouse checks
            // (or it's a double click)
            // calculate both time and distance of mouse movement
            // to check for threshholds being met

            let mouseHoldLength = new Date() - this.mouseClickStartedAt,
                mouseEndPos = getMouseCoordinates(e),
                mouseDeltaX = mouseEndPos.x - this.mouseMoveStartPos.x,
                mouseDeltaY = mouseEndPos.y - this.mouseMoveStartPos.y,
                mouseDistanceTraveled = Math.sqrt(mouseDeltaX * mouseDeltaX + mouseDeltaY * mouseDeltaY)

            // reset distance-related variables
            this.mouseMoveStartPos = undefined

            // if threshholds are met, trigger a UI toggle
            if (mouseHoldLength < MOUSE_CLICK_THRESHHOLD_MS && mouseDistanceTraveled < MOUSE_DISTANCE_THRESHHOLD_PX) {
                this.toggleUIVisibility()
            }
        }

        // flag video as no longer being moved
        this.isVideoBeingMoved = false
    }

    handleChange = e => {
        if (!isPhone) {
            this.hideUI(UIHideTiming.slow)
        }
    }

    handleHoverUIControls = e => {
        this.isMouseOnVideo = false
        this.props.showVideoUI()
    }

    handleHoverUIControlsEnd = e => {
        this.isMouseOnVideo = true
        this.hideUI(UIHideTiming.FAST)
    }

    initializeAudio = () => {
        const { audioManager, autoplay, audioType } = this.props

        if (!this.props.isVideoVolumeMuted) {
            this.state.player.setVolume(this.props.videoVolume / 100.0)
        } else {
            this.state.player.setVolume(0)
        }

        if (audioManager.getIn(['state', audioType]) != AUDIO_PLAY && autoplay !== false) {
            this.props.playAudio(audioType)
        }
    }

    hideUI = (time = 0) => {
        const { player } = this.state

        if (this.props.isVideoUIVisible) {
            this.props.startHideVideoUITimer({
                getHideCondition: () =>
                    player && player.isPlaying() && (isMobile || this.isMouseOnVideo) && this.props.isVideoUIVisible, // don't hide if we're already visible, of course
                time: typeof time == 'number' ? time : 0,
            })
        }
    }

    setVideoQuality = () => {
        const { setCurrentQuality, setVideoQuality } = this.props

        this.state.player.getQuality((videoQuality, videoQualities) => {
            // parse out only value & display from qualities
            const list = videoQualities.map(q => ({ value: q.value, display: q.display }))

            setCurrentQuality(videoQuality == 'unknown' ? 'auto' : videoQuality)
            setVideoQuality(list)
        })
    }

    is360 = () => this.props.options.playback_type == VideoPlayer.playbackTypes.THREE_SIXTY

    isAWS = () => this.props.options.type == VideoPlayer.types.AWS

    render() {
        const { player } = this.state
        const { audioType, isVideoUIVisible, options, hasIntroVideoPlayed } = this.props

        const videoId = options.videoid
        const videoType = options.type

        // defining this prevents doubling up on events
        let containerInteractionProps = !isMobile
            ? {
                  onMouseDown: this.handleVideoAreaClick,
                  onMouseMove: this.handleMouseMove,
                  onMouseUp: this.handleMouseUp,
              }
            : {
                  onTouchStart: this.handleVideoAreaClick,
                  onTouchMove: this.handleMouseMove,
                  onTouchEnd: this.handleMouseUp,
              }

        let cursorClassName

        if (!this.is360()) {
            cursorClassName = 'video_pointer'
        } else {
            cursorClassName = this.state.isMouseDown ? 'video_player_grabbing' : 'video_player_grab'
        }

        const isDesktopYTModal =
            player && player.type == VideoPlayer.types.YOUTUBE && !isMobile && this.props.isFromModal

        return (
            <div>
                {this.state.shouldShowDragHint && this.is360() && !isVideoUIVisible && <DraggingHint />}
                <Style>
                    {`
                        .video_player_grab {
                            cursor: move;
                            cursor: url(${grabCursor});
                            cursor: -webkit-grab;
                            cursor: -moz-grab;
                            cursor: grab;
                        }

                        .video_player_grabbing {
                            cursor: url(${grabbingCursor});
                            cursor: -webkit-grabbing;
                            cursor: -moz-grabbing;
                            cursor: grabbing;
                        }

                        .video_player_cursor {
                            cursor: pointer;
                        }
				    `}
                </Style>

                <div
                    ref={c => (this.R.videoPlayerWrapper = c)}
                    className={cursorClassName + ' video_player_wrapper_div'}
                    style={this.getContainerParentStyle({
                        cursorClassName,
                        originalStyle: this.props.style,
                    })}
                    {...containerInteractionProps}
                >
                    <div
                        className={'video_player_div'}
                        style={
                            (this.is360() || this.isAWS() || isPhone || isDesktopYTModal) && !hasIntroVideoPlayed
                                ? S.videoWithPointerEvents
                                : S.videoWithoutPointerEvents
                        }
                    >
                        <span ref={c => (this.R.videoPlayer = c)} />
                        {videoType === VideoPlayer.types.YOUTUBE && (
                            <>
                                <YouTubeIframe videoId={videoId} height="600px" width={'100%'} />
                            </>
                        )}
                        {isVideoUIVisible && player && (
                            <VideoPlayerUI
                                audioType={audioType}
                                onControlsHover={this.handleHoverUIControls}
                                onControlsHoverEnd={this.handleHoverUIControlsEnd}
                                onChange={this.handleChange}
                                onPlay={this.handlePlay}
                                onPause={this.props.showVideoUI}
                                isVideoPlaying={this.state.isVideoPlaying}
                                //style={S.videoUIContainer}
                                theme={Object.assign({}, options.theme, {
                                    platform: isPhone ? PLATFORM.mobile : PLATFORM.desktop,
                                })}
                                player={this.state.player}
                            />
                        )}
                        {this.props.altMainMedia && this.state.player && (
                            <SkipButton
                                title={this.props.altMainMedia.skipButtonTitle}
                                theme={isMobile ? PLATFORM.mobile : PLATFORM.desktop}
                                player={this.state.player}
                                tabIndex={VIDEO_SKIP_INDEX}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    connect(state => ({
        isDraggingHintVisible: state.getIn(['video', 'draggingHint', 'isVisible']),
        isRegistrationOpen: state
            .getIn(['modal', 'modalStack'])
            .some(modal =>
                [ModalContentTypes.WELCOME_REGISTRATION, ModalContentTypes.REGISTRATION].includes(modal.content.type)
            ),
    })),
    connect(
        mapSelectorsToProps([
            'allowedAudio',
            'audioManager',
            'videoQuality',
            'videoQualityOptions',
            'stopCardsState',
            'altMainMedia',
            'isMediatour',
            'isVideoUIVisible',
            'videoVolume',
            'isVideoVolumeMuted',
            'videoStartTime',
            'panoStartLatLon',
            'drawer',
            'hasIntroVideoPlayed',
        ]),
        {
            stopAudio,
            playAudio,
            playVideo: VideoPlayerActions.playVideo,
            dragVideoEnd: VideoPlayerActions.dragVideoEnd,
            setVideoQuality: VideoPlayerActions.setVideoQuality,
            setCurrentQuality: VideoPlayerActions.setCurrentQuality,
            hideContextMenu,
            hideCustomMedia,
            showUIButton,
            isAutoPlayBlocked,
            setStartTime: VideoPlayerActions.setStartTime,
            startHideVideoUITimer: VideoPlayerActions.startHideVideoUITimer,
            cancelHideVideoUITimer: VideoPlayerActions.cancelHideVideoUITimer,
            showVideoUI: VideoPlayerActions.showVideoUI,
            hideVideoUI: VideoPlayerActions.hideVideoUI,
            registerVideoPlayer: VideoPlayerActions.registerVideoPlayer,
            setPanoStartLatLon,
            setDragHintDetails,
            hideDescription,
        }
    )
)(VideoPlayerWrapper)
